module.exports = __webpack_public_path__ + "static/media/19.dbd8d0e2.jpg";